import { render, staticRenderFns } from "./congrats.vue?vue&type=template&id=3d39a99d&scoped=true"
import script from "./congrats.vue?vue&type=script&lang=js"
export * from "./congrats.vue?vue&type=script&lang=js"
import style0 from "./congrats.scss?vue&type=style&index=0&id=3d39a99d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d39a99d",
  null
  
)

export default component.exports